module.exports = __webpack_public_path__ + "img/TCT.5b14a920.jpg";